export default __webpack_public_path__ + "static/bg-a9d9f94b52a89d8a7a20d6b3530ea7d0.jpg";